import { FormControlLabel, Radio, Typography, useTheme } from "@mui/material";
import { CustomRadioProps } from "../types";

import mastercard from "@/assets/icons/payNow/mastercard.jpg";
import visa from "@/assets/icons/payNow/visa.jpg";
import amex from "@/assets/icons/payNow/american-express.jpg";
import defaultCart from "@/assets/icons/payNow/defaultCreditCard.jpg";
import diners_club_international from "@/assets/icons/payNow/dinersclub.jpg";
import discover from "@/assets/icons/payNow/discover.jpg";
import jcb from "@/assets/icons/payNow/jcbcc.png";
import laser from "@/assets/icons/payNow/lasercc.png";
import maestro from "@/assets/icons/payNow/maestro.jpg";
import paypal from "@/assets/icons/payNow/paypal.jpg";
import visa_electron from "@/assets/icons/payNow/visaelectron.jpg";

const brandIcons: Record<string, string> = {
  Visa: visa,
  Master: mastercard,
  "American Express": amex,
  "Diners Club International": diners_club_international,
  Discover: discover,
  Jcb: jcb,
  Laser: laser,
  Maestro: maestro,
  "Visa Electron": visa_electron,
  Paypal: paypal,
};

const CustomRadio = ({
  idValidPay,
  brand,
  last4,
  name,
  id,
  price,
  checked,
  label,
}: CustomRadioProps) => {
  const theme = useTheme();
  const iconSrc = brandIcons[brand ?? ""] || defaultCart;

  return (
    <FormControlLabel
      sx={{
        border: "1px solid",
        backgroundColor: checked ? "#FFFDFB" : "inherit",
        borderColor: checked ? theme.palette.primary.main : "#E5E5E5",
        ...(idValidPay && {
          paddingTop: "10px",
          paddingBottom: "7px",
          display: "flex",
          flexDirection: "row-reverse",
        }),
      }}
      value={id}
      control={<Radio sx={{ color: "#E4DED9" }} />}
      label={
        <>
          {idValidPay ? (
            <div
              style={{
                justifyContent: "flex-start",
                alignItems: "center",
                display: "flex",
              }}
            >
              <div
                style={{
                  marginRight: "1rem",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <img
                  src={iconSrc}
                  alt={brand}
                  style={{ width: 56, height: 40, objectFit: "contain" }}
                />
              </div>

              <div style={{ display: "flex", flexDirection: "column" }}>
                <Typography component="span">
                  {idValidPay ? brand : name}
                </Typography>
                <Typography component="span" style={{ color: "#707580" }}>
                  **** **** **** {idValidPay ? last4 : name}
                </Typography>
              </div>
              {price ? <Typography component="span">{price}</Typography> : null}
            </div>
          ) : (
            <>
              <Typography component="span">
                {idValidPay ? brand : name}
              </Typography>
              {price ? (
                <Typography component="span">${price}</Typography>
              ) : null}
              {label ? <Typography component="span">{label}</Typography> : null}
            </>
          )}
        </>
      }
    />
  );
};

export default CustomRadio;
